import React from "react";
import Modal from "react-modal";

import { db } from "../firebase-config";
import { collection, addDoc } from "firebase/firestore";
import { UserContext } from "../UserContext";
import { formatDate } from "../utils/standaloneUtils";

import styles from "./ModalWebPushConfirm.module.css";
import Popover from "./Popover/Popover";

const ModalWebPushConfirm = ({ isOpen, onRequestClose, data, setData }) => {
  const [loading, setLoading] = React.useState(false);
  const [isAlertOpen, setIsAlertOpen] = React.useState(false);

  const { data: dataUser } = React.useContext(UserContext);
  async function postNotificationFirebase(collectionName, dataNotification, changeRoute = false) {
    const response = await addDoc(
      collection(db, collectionName),
      dataNotification
    );
    changeRoute && (location.href = "/web-push-agendamentos-2")
  }
  async function postNotificationFirebaseCreateNew(collectionName, dataNotification) {
    const response = await addDoc(
      collection(db, collectionName),
      dataNotification
    );
    onRequestClose()

    setTimeout(() => {
      setIsAlertOpen(false)
    }, 3000);
  }
  function formatDate(date) {
    let dateFormated;
    let t;
    let seconds;
    try {
      //seconds = date.toString().split('seconds=')[1].split(',')[0];
      t = new Date(date); // Epoch
      //t.setSeconds(seconds);
      let minutos = Number(t.getMinutes());
      if (minutos < 10) {
        minutos = "0" + minutos;
      }

      dateFormated =
        t.getDate() +
        "/" +
        Number(t.getMonth() + 1) +
        "/" +
        t.getFullYear() +
        " " +
        Number(t.getHours()) +
        ":" +
        minutos;
    } catch (e) {
      dateFormated = "";
    }

    return dateFormated;
  }
  function handleConfirmDate() {
    let dateNow = new Date();
    try {
      setLoading(true);
      postNotificationFirebase("agendamentos-web-push", {
        ...data,
        dateSend: dateNow,
        status: "agendado",
      });
      postNotificationFirebase("registros-envios-web-push", {
        ...data,
        emailSended: dataUser?.email,
        dateSend: dateNow,
        status: "agendado",
      }, true);
    } catch (error) {
      console.error(error);
    } finally {
      setData({
        title: "",
        body: "",
        url: "",
        img: "",
        tokensQtd: data.tokensQtd,
        dateSchedule: data.dateSchedule,
        audience: data.audience,
      });

      setLoading(false);
      setIsAlertOpen(true)
    }
  }
  function handleConfirmCreateNew() {
    let dateNow = new Date();
    try {
      setLoading(true);
      postNotificationFirebaseCreateNew("agendamentos-web-push", {
        ...data,
        dateSend: dateNow,
        status: "agendado",
      });
      postNotificationFirebaseCreateNew("registros-envios-web-push", {
        ...data,
        emailSended: dataUser?.email,
        dateSend: dateNow,
        status: "agendado",
      });
    } catch (error) {
      console.error(error);
    } finally {
      setData({
        title: "",
        body: "",
        url: data.url ? data.url : "https://www.santander.com.br/",
        img: "https://www.santander.com.br/sites/WPC_Banco/assets/images/oferta-contextual/logo_santander_100x100_v0_chama_verm.jpg",
        imgDestaque: "https://www.santander.com.br/sites/WPC_Banco/assets/images/hospedagem-imagens/logo-santander-webpush.jpg",
        dateSchedule: data.dateSchedule,
        audience: data.audience,
        urlFluxo: data.urlFluxo,
        tokensQtd: data.tokensQtd,
        hasImageToShow: data.hasImageToShow ? data.hasImageToShow : null,
        hasCutoffDate: data.hasCutoffDate ? data.hasCutoffDate : null,
        cutofDate: data.cutofDate ? data.cutofDate : null,
        recurrence: data.recurrence ? data.recurrence : null,
        recurrenceCheckboxWeekly: data.recurrenceCheckboxWeekly ?
          data.recurrenceCheckboxWeekly :
          null,
        recurrenceSendPost: data.recurrenceSendPost ? data.recurrenceSendPost : null,
        recurrenceDayMonth: data.recurrenceDayMonth ? data.recurrenceDayMonth : null,
        recurrenceTime: data.recurrenceTime ? data.recurrenceTime : null,
      });

      setLoading(false);
      setIsAlertOpen(true)
    }
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        contentLabel="Selected Option"
        overlayClassName="react-modal-overlay"
        className="react-modal-content"
        onRequestClose={onRequestClose}
      >
        <button
          className="react-modal-close"
          type="button"
          onClick={onRequestClose}
        >
          <span>&#x2715;</span>
        </button>
        <div className={styles.containerText}>
          <h2>Confirma o agendamento da Notificação?</h2>
          <p>Data de agendamento: {`${formatDate(data.dateSchedule)}`}</p>
          <p>Publico: {data.audience}</p>
          <p>Clientes impactados: {data.tokensQtd}</p>
          <p>Titulo: {data.title}</p>
          <p>Descrição: {data.body}</p>
          <p style={{ lineBreak: "anywhere" }}>Link: {data.url}</p>
          <p>Image:</p>
          <img src={data.img} />
          {loading ? (
            <button disabled>Agendando notificação...</button>
          ) : (
            <>
              <button onClick={handleConfirmDate}>Confirmar Agendamento</button>
              <button onClick={handleConfirmCreateNew}>Confirmar e cadastrar outro</button>
            </>
          )}
        </div>
      </Modal>
      <Popover
        isOpen={isAlertOpen}
        warningTitle={'Agendamento realizado com sucesso!'}
      />
    </>
  );
};

export default ModalWebPushConfirm;
